import { useMemo } from "react";
import { IColumnProps } from "devextreme-react/data-grid";

import { ILogger } from "@ezhou/common";
import { PageProps } from "@ezhou/core";

import { createFormulaEditCellComponent } from "../../components/formulaEditor";
import { FormulaContextKeys } from "../../model/formula";

import { OrganizationChildCrudDataGrid } from "../common/OrganizationChildCrudDataGrid";

import {
  dummyJournalEntryExportSettingFieldRow,
  journalEntryExportSettingFieldColumns,
} from "./model/metaData";

const FORMULA_FIELDS = ["fieldValueFormula"];

export type JournalEntryExportSettingFieldsProps = {
  parentKey: any;
  pageProps: PageProps;
  logger: ILogger;
};

export const JournalEntryExportSettingFields = (props: JournalEntryExportSettingFieldsProps) => {
  const baseUrl = "journal-entry-export-setting-fields";
  const dataKey = "journalEntryExportSettingFieldId";

  const dataToBeFiltered = [
    "journalEntryExportSetting",
    "exportSettingName",
  ];

  const dataToBeFilteredForForm = [dataKey];

  const httpClient = props.pageProps.appUtil.httpClients["eAccountingService"];

  // Render the formula editor through the column's `editCellComponent` so the DataGrid's editing
  // controller supplies the current value and receives changes. A form-item template would bypass
  // that binding and open with an empty editor for existing rows.
  const formulaEditCellComponent = useMemo(
    () =>
      createFormulaEditCellComponent({
        httpClient,
        contextKey: FormulaContextKeys.TessituraContext,
        rootObjects: ["JournalEntry"],
      }),
    [httpClient],
  );

  const columnConfigs = useMemo(() => {
    const configs = new Map<string, IColumnProps>(journalEntryExportSettingFieldColumns);
    FORMULA_FIELDS.forEach((field) => {
      const existing = configs.get(field) ?? { dataField: field };
      configs.set(field, { ...existing, editCellComponent: formulaEditCellComponent });
    });
    return configs;
  }, [formulaEditCellComponent]);

  return (
    <>
      <div>Fields</div>
      <OrganizationChildCrudDataGrid
        pageProps={props.pageProps}
        logger={props.logger}
        dummyRow={dummyJournalEntryExportSettingFieldRow}
        keyExpr={dataKey}
        isKeyAutoGenerated={true}
        baseUrl={baseUrl}
        parentKey={props.parentKey}
        dataToBeFiltered={dataToBeFiltered}
        formTitle="Add Field"
        formColCount={2}
        formColSpan={2}
        allowAdding={true}
        allowUpdating={true}
        allowDeleting={true}
        dataToBeFilteredForForm={dataToBeFilteredForForm}
        hideColumnChooser={true}
        hideSearchPanel={true}
        hideInactiveButton={true}
        columnConfigs={columnConfigs}
      />
    </>
  );
};
